export default __webpack_public_path__ + "static/HelveticaMonospacedPro-Rg-cc3e2d0858c5bf83b34b325ca66f7411.otf";